<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <soil-test-results-nsdas-form
      :id="id"
      :title="title"
      :item="item"></soil-test-results-nsdas-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
